module.exports = __webpack_public_path__ + "assets/bgPhone.b7b401d112eceeabc1d97c67fec2d0f4a6c6946a4676d87f8bf868f456682e22.jpg";